module.exports = __webpack_public_path__ + "static/media/upload_manual.c12bcdac.svg";